import { Injectable } from '@angular/core';
import { Response, ResponseContentType, RequestOptions, URLSearchParams } from '@angular/http';

import { Ticket } from '../../../../../../data/models/transaction/op/outbound/ticket/index';
import { AuthHttp, QueryEncoderHelper } from '../../../../../common/index';
import { AppSettings } from '../../../../../settings/index';

@Injectable()
export class TicketService {
    constructor(private http: AuthHttp) { }

    save(ticket: { [k: string]: any }) {
        return this.http.post(AppSettings.apiEndpoint + "Ticket/Save", ticket)
            .map((response: Response) => response.json());
    }

    getForTracking(ownerCode: string, statusCode: string, bookingNo: string, fromETADateString: string, toETADateString: string, groupId: string) {
        let params: URLSearchParams = new URLSearchParams();
        params.set('ownerCode', ownerCode);
        params.set('statusCode', statusCode);
        params.set('bookingNo', bookingNo);
        params.set('fromETADateString', fromETADateString);
        params.set('toETADateString', toETADateString);
        params.set('groupId', groupId);

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.get(AppSettings.apiEndpoint + 'Ticket/GetForTracking', options)
            .map((response: Response) => response.json());
    }

    getByOwnerAndETADate(ownerCode: string, etaDateString: string) {
        let params: URLSearchParams = new URLSearchParams();
        params.set('ownerCode', ownerCode);
        params.set('etaDateString', etaDateString);

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.get(AppSettings.apiEndpoint + 'Ticket/GetByOwnerAndETADate', options)
            .map((response: Response) => response.json());
    }

    generateTicket(ownerCode: string, bookingNo: string) {
        let params: URLSearchParams = new URLSearchParams();
        params.set('ownerCode', ownerCode);
        params.set('bookingNo', bookingNo);

        let options: RequestOptions = new RequestOptions({ search: params, responseType: ResponseContentType.Blob  });
        return this.http.get(AppSettings.apiEndpoint + 'Ticket/GenerateTicket', options)
            .map(
            (response: Response) => {
                let contentType = response.headers.get('Content-Type');
                return new Blob([response.blob()], { type: contentType });
            });
    }

    getUnavailableDates() {
        
        return this.http.get(AppSettings.apiEndpoint + "Ticket/GetUnavailableDates")
            .map((response: Response) => response.json());
    }
}



// WEBPACK FOOTER //
// ./src/app/infrastructure/services/transaction/op/outbound/ticket/ticket.service.ts